import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'inside-out/components/shared/link';
import { format } from 'inside-out/managers/dateManager';

import StandardIcon from 'inside-out/images/media-office/standard-icon.svg';
import { wrapperStyle, wrapperLinkStyle, metaDateStyle, titleStyle, bodyStyle } from './styles';

class MediaCardComponent extends React.PureComponent {
	render() {
		const { id, to, title, body, date, background, hasVideo } = this.props;

		return (
			<Link className={wrapperLinkStyle} to={to} data-component="Card">
				<article className={wrapperStyle(background, hasVideo)} id={`item-${id}`}>
					{!background && !hasVideo && <img src={StandardIcon} alt="" />}
					<h1 className={titleStyle}>{title}</h1>
					{!background && <p className={bodyStyle}>{body}</p>}
					<p className={metaDateStyle}>{format(date)}</p>
				</article>
			</Link>
		);
	}
}

MediaCardComponent.propTypes = {
	id: PropTypes.string,
	to: PropTypes.string,
	hasVideo: PropTypes.bool,
	title: PropTypes.string,
	body: PropTypes.string,
	date: PropTypes.string,
	background: PropTypes.string,
};

export const MediaCard = MediaCardComponent;



// WEBPACK FOOTER //
// ./src/components/shared/cards/mediaCard/component.js